/**************************************************************************************
 * 加密相关常量
 *      注：此处的所有字段名，需与后端保持一致
 *         SM2公钥/私钥若需更换，需与后端成套替换
 *
 * @author Francis
 * @since 2024-03-14 11:10
 * @version 1.0
 ***************************************************************************************/
// 全局配置-参数加密标识符：true-开启、false-关闭
export const paramEncryptConfig = false;
// 全局配置-签名校验标识：true-开启、false-关闭
export const verifySignConfig = false;
// hmacsha256密钥：用于生成签名
export const hmacSHA256Key = "zcgk-animal-feed-mis";
// sm2加密模式：0、1：此处若修改，需与后端保持一致
export const sm2Mode = 1;
// sm2公钥：用于加密sm4的密钥，与后端成对
export const sm2PublicKey4RequestEncrypt = "04159a6e725c165db067923e6d1b11c2391c37cf1f5f6f68c88e3907c07e20a142791760d50fd06716d644e8b365a712b4daf894435671df4f115048be1d46aa81";
// sm2公钥：用于加密请求头标识符，与后端成对
export const sm2PublicKey4HeaderEncrypt = "045511b5ff5feab4075b87b25ff4df3a5aabd25a7a15f57bfe576239cfd1aecc3966c50e3af7111b9078bbfec55da219f1883a998ce9ca5863c7526729c9bd4bb2";
// sm2私钥：用于解密响应数据，与后端成对
export const sm2PrivateKey4ResponseDecrypt = "afb6a2bde3f83e5de7b97c0457f496693b3faccf9c43c8cf652d98c2a0b74751";
// 参数加密排除的字段名，如：分页条件等，不参与参数加密
export const excludeEncryptField = ["pageSize", "currentPage"];
